/**
 * VERON · Verpackungswahl im Warenkorb
 * ------------------------------------
 * Liegt bewusst NICHT im Baustein. Der Warenkorb erscheint an zwei Stellen:
 * auf der Warenkorbseite und in der Schublade — und die Schublade wird bei
 * jeder Änderung über die Section-Rendering-API neu gerendert, wobei
 * eingebettete <script>-Tags NICHT erneut ausgeführt werden.
 *
 * Deshalb: eine einzige Bindung am document (Ereignisdelegation). Sie
 * überlebt jedes Neu-Rendern, weil sie nie am neuen Markup hängt.
 *
 * Nach einer Änderung wird `shopify:cart:lines-update` ausgelöst — darauf
 * hört `component-cart-items.js` und holt seinen Abschnitt selbst nach.
 * Das Ereignis braucht ein `promise`: der Zuhörer ruft `event.promise?.then`
 * und tut ohne es gar nichts. Kommen keine Abschnitte mit, rendert er neu.
 * Falls das aus irgendeinem Grund nicht greift, lädt der Notnagel nach
 * 1,6 s die Seite — lieber ein harter Neuaufbau als ein Knopf, der
 * scheinbar nichts tut.
 */
(function () {
  'use strict';
  if (window.__veronPackGebunden) return;
  window.__veronPackGebunden = true;

  var LADEN = 1600;
  var AUS = 'veron:pack:aus';

  /* Weggeklickt gilt fuer DIESEN Besuch, nicht fuer immer: sessionStorage
     statt localStorage. Wer beim naechsten Einkauf wiederkommt, bekommt das
     Angebot erneut — ein dauerhaft verstecktes Angebot waere praktisch
     geloescht, und das hat niemand verlangt.
     Die Klasse wird SOFORT gesetzt, nicht erst bei DOMContentLoaded: das
     Skript laeuft mit `defer` nach dem Parsen, aber vor dem ersten Zeichnen
     — so blitzt der Block nicht kurz auf, bevor er verschwindet. */
  function versteckt() {
    try { return sessionStorage.getItem(AUS) === '1'; } catch (e) { return false; }
  }
  if (versteckt()) document.documentElement.classList.add('veron-pack-aus');

  function sperren(wurzel) {
    if (!wurzel) return;
    wurzel.querySelectorAll('button').forEach(function (b) {
      b.disabled = true;
      b.style.opacity = '.55';
    });
  }

  function auffrischen(vorher) {
    var ev;
    try {
      ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      ev.promise = Promise.resolve({ detail: {} });
      document.dispatchEvent(ev);
    } catch (e) {
      window.location.reload();
      return;
    }
    // Notnagel: hat sich der Zustand nach LADEN ms nicht geaendert, neu laden.
    window.setTimeout(function () {
      var jetzt = document.querySelectorAll('[data-veron-pack-remove]').length;
      if (jetzt === vorher) window.location.reload();
    }, LADEN);
  }

  function hinzufuegen(btn) {
    var wurzel = btn.closest('[data-veron-pack]');
    var vid = Number(btn.getAttribute('data-veron-pack-add'));
    if (!vid) return;
    var vorher = document.querySelectorAll('[data-veron-pack-remove]').length;
    sperren(wurzel);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function () { auffrischen(vorher); })
      .catch(function () { window.location.reload(); });
  }

  function entfernen(btn) {
    var wurzel = btn.closest('[data-veron-pack]');
    var handle = wurzel ? wurzel.getAttribute('data-handle') : null;
    if (!handle) return;
    var vorher = document.querySelectorAll('[data-veron-pack-remove]').length;
    sperren(wurzel);
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var zeile = 0;
        c.items.forEach(function (it, i) { if (it.handle === handle) zeile = i + 1; });
        if (!zeile) { window.location.reload(); return null; }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: zeile, quantity: 0 })
        });
      })
      .then(function (r) { if (r) auffrischen(vorher); })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;

    var add = ziel.closest('[data-veron-pack-add]');
    if (add) { e.preventDefault(); hinzufuegen(add); return; }

    var weg = ziel.closest('[data-veron-pack-remove]');
    if (weg) { e.preventDefault(); entfernen(weg); return; }

    var zuKnopf = ziel.closest('[data-veron-pack-hide]');
    if (zuKnopf) {
      e.preventDefault();
      try { sessionStorage.setItem(AUS, '1'); } catch (err) {}
      document.documentElement.classList.add('veron-pack-aus');
      return;
    }

    var wie = ziel.closest('[data-veron-pack-how]');
    if (wie) {
      e.preventDefault();
      var huelle = wie.closest('[data-veron-pack-huelle]') || document;
      var dlg = huelle.querySelector('[data-veron-pack-dlg]')
             || document.querySelector('[data-veron-pack-dlg]');
      if (dlg) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
      return;
    }

    var zu = ziel.closest('[data-veron-pack-close]');
    if (zu) {
      e.preventDefault();
      var d = zu.closest('dialog');
      if (d) { if (d.close) d.close(); else d.removeAttribute('open'); }
      return;
    }

    // Klick auf den Hintergrund des Dialogs schliesst ihn.
    if (ziel.matches && ziel.matches('[data-veron-pack-dlg]')) ziel.close();
  });
})();
